import React, { useState, useEffect } from "react";
import StarRatings from "react-star-ratings";
import { Link } from "react-router-dom";

import "pure-react-carousel/dist/react-carousel.es.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductModal from "../ProductModal/ProductModal";
// icon component
// const IconComponent = () => {
//   const [addToWish, setAddToWish] = useState(false);
//   const callAddToWish = () => {
//     setAddToWish(!addToWish);
//   };
//   return (
//     <div className="heart-icon">
//       <i
//         className={addToWish ? "far fa-heart iconBold" : "far fa-heart"}
//         onClick={callAddToWish}
//       />
//     </div>
//   );
// };

const SingleProduct = (props) => {
  const [link, setLink] = useState("");
  const [parentModel, setParentModel] = useState("");
  const [show, setShow] = useState(false);
  const [quickViewId, setquickViewId] = useState("");
  const [pictureCheck, setPictureCheck] = useState(false);
  const [optionsCount, setOptionsCount] = useState(0);
  const [heart, setHeart] = useState(false);
  useEffect(() => {
    if (
      catagoryConfigurationDetails &&
      catagoryConfigurationDetails.length !== 0
    ) {
      catagoryConfigurationDetails.map((item) => {
        if (item.outputField === "pictures") {
          setPictureCheck(true);
        }
      });
    }
    if (item.count && item.count.length !== 0) {
      console.log(item.count);
      let temporaryCount = 0;
      item.count.map((item) => {
        if (
          item !== null &&
          item.attributeId !== "5f7709258d049b1b5897c3fd" &&
          item.attributeId !== "5f7709258d049b1b5897c437"
        ) {
          temporaryCount = temporaryCount + item.count + 1;
        }
      });
      setOptionsCount(temporaryCount);

      console.log("temporaryCount ", temporaryCount);
    }
  }, [props.catagoryConfigurationDetails, props.item]);

  const callAddToWish = (item) => {
    setHeart(!heart);
  };
  const _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "A" });
        }
      });
      if (a === true) {
        arr.push(item);
        callAddToWish(item._id);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      setShow(false);
      toast(`Product added to wishlist`, { containerId: "A" });
    }
  };

  const _openModal = (e, item) => {
    e.preventDefault();
    setShow(true);
    setquickViewId(item);
  };

  const {
    item,
    groupLoading,
    loading,
    configuration,
    catagoryConfigurationDetails,
    count,
    slug,
  } = props;
  console.log(props);

  return (
    <React.Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <div className="col-md-3 my-3 col-sm-6 col-12 borderBottom-1">
        <div className="product-cards">
          <Link
            className="d-block h-100 text-color"
            target="_blank"
            to={`/product/${item.slug}?${slug}`}
          >
            <div className="product-cards-img">
              {item.parentModel !== parentModel ? (
                <div
                  style={{
                    backgroundImage: `url(${item.mainImage})`,
                    backgroundSize: "contain",
                    height: "100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                ></div>
              ) : (
                <div
                  style={{
                    backgroundImage: `url(${link})`,
                    backgroundSize: "contain",
                    height: "100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                ></div>
              )}

              {/* <div style={{backgroundImage: `url(${item.images[0]})`, backgroundSize: "contain", height: "100%", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}></div>            */}
              {/* <img src={`${item.images[0]}`} width="100%" alt="" /> */}
            </div>
            <div className="card-inner-area">
              <span className="sale-sticker">Sale</span>
              <span
                className="sale-wish"
                onClick={(e) => {
                  e.preventDefault();
                  _addToWishlist(item && item);
                }}
              >
                <div className="heart-icon">
                  <i
                    className={heart ? "far fa-heart iconBold" : "far fa-heart"}
                  />
                </div>
              </span>
              <div className="quick-view-btn">
                <Link onClick={(e) => _openModal(e, item._id)}>
                  <span>Quickview</span>
                </Link>
              </div>
            </div>

            <div className="">{}</div>
            <div className="product-cards-price">
              {!loading ? (
                <div>
                  {configuration && configuration.status === true ? (
                    <div className="">
                      {!groupLoading && item.grouping ? (
                        <div className="d-flex flex-wraped">
                          {catagoryConfigurationDetails &&
                            catagoryConfigurationDetails.length > 0 &&
                            catagoryConfigurationDetails.map(
                              (item1, index1) => (
                                <div className={`${index1 === 1 ? "" : ""}`}>
                                  {item.count &&
                                    item.count.map((item2) => (
                                      <>
                                        <div className="">
                                          {item2 !== null &&
                                          item1.keyFieldId ===
                                            item2.attributeId &&
                                          (item2.attributeId ===
                                            "5f7709258d049b1b5897c3fd" ||
                                            item2.attributeId ===
                                              "5f7709258d049b1b5897c437") ? (
                                            <p>
                                              + {item2.count + 1}
                                              {item1.title}
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </>
                                    ))}
                                </div>
                              )
                            )}
                          <>
                            {optionsCount !== 0 ? (
                              <p className="ml-2">
                                + {optionsCount}
                                options
                              </p>
                            ) : (
                              ""
                            )}
                          </>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="d-flex"></div>
                      {!groupLoading && item.grouping ? (
                        <div className="row ml-1">
                          {pictureCheck ? (
                            item.grouping &&
                            item.grouping.length > 0 &&
                            item.grouping.slice(0, 5).map((group, indx) => (
                              <div
                                className="numberingBorder"
                                style={{
                                  borderRadius: "7px",
                                  margin: "4px 2px 0 0",
                                  border: "1px solid #e3e3e3",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "1px",
                                }}
                                key={indx}
                              >
                                <Link
                                  to={`/product/${group.slug}?${slug}`}
                                  onMouseEnter={() => {
                                    setLink(group.mainImage);
                                    setParentModel(group.parentModel);
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundImage: `url(${
                                        group &&
                                        group.mainImage &&
                                        group.mainImage
                                      })`,
                                      backgroundSize: "contain",
                                      backgroundRepeat: "no-repeat",
                                      backgroundPosition: "center",
                                      height: "25px",
                                      width: "25px",
                                      borderRadius: "7px",
                                    }}
                                  ></div>
                                </Link>
                              </div>
                            ))
                          ) : (
                            <div></div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="product-cards-content">
              <div className="product-cards-txt">
                <div className="row">
                  {item.grouping && item.grouping.length > 4 && (
                    <div className="col-md-2 col-sm-2 col-2">
                      {item.grouping.length - 5 === 0 ? (
                        ""
                      ) : (
                        <Link
                          to={`/product/${item.slug}?${slug}`}
                          className="grouping-left"
                        >
                          <div
                            style={{
                              borderRadius: "7px",
                              margin: "4px 2px 0 0",
                              border: "1px solid #e3e3e3",
                              display: "flex",
                              alignItems: "center",
                              padding: "1px",
                              justifyContent: "center",
                              textAlign: "center",
                              background: "#ecedef",
                            }}
                          >
                            {item.grouping.length - 5}+
                          </div>
                        </Link>
                      )}
                    </div>
                  )}
                </div>
                <Link to={`/product/${item.slug}?${slug}`}>
                  {item && item.title}
                </Link>
                <div className="product-cards-price">
                  <span>
                    $
                    {item.enableSale === true
                      ? Number(
                          item.price - (item.price * item.saleDiscount) / 100
                        ).toFixed(2)
                      : Number(item.price).toFixed(2)}
                  </span>
                  <span>
                    {item.enableSale === true ? (
                      <del>${Number(item.price).toFixed(2)}</del>
                    ) : null}
                  </span>
                </div>

                <div className="product-cards-rating">
                  <ul className="product-rating">
                    <StarRatings
                      rating={
                        item.reviews ? item.reviews / item.reviewCount : 0
                      }
                      starDimension="20px"
                      starSpacing="2px"
                      starRatedColor="gold"
                    />
                    <span>{item.reviewCount}</span>
                  </ul>

                  <span className="text-color">
                    {item.price > 49 ? <b>Free Shipping</b> : <b></b>}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      {show ? <ProductModal show={show} id={quickViewId} /> : ""}
    </React.Fragment>
  );
};

export default SingleProduct;
